
































    import { Component, Prop, Vue } from 'vue-property-decorator';
    import { differenceInDays } from 'date-fns';
    import { formatDateWithTimezone, getRelativeDate, getTimeZoneString, isoFormatLong2 } from '@/date-time/date-time-utils';

@Component
    export default class TaskDueBar extends Vue {
    @Prop({ required: true }) dueDateTime!: string;
    @Prop({ required: true }) timezone!: string;
    @Prop({ default: false }) isMeeting!: boolean;
    @Prop({ default: false }) isComplete!: boolean;
    @Prop() completedDateTime?: string;
    @Prop({ default: null }) label?: string | null;

    get relativeDate(): string {
        return getRelativeDate(this.dueDateTime, this.timezone);
    }

    get barColorClass(): string {
        const today = new Date();
        const dueDate = new Date(formatDateWithTimezone(this.dueDateTime, this.timezone, isoFormatLong2));

        // Set both dates to midnight in the current timezone for comparison
        const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const dueDateDate = new Date(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate());
        const daysDiff = differenceInDays(dueDateDate, todayDate);

        if (this.isComplete && this.completedDateTime) {
            const completedDate = new Date(formatDateWithTimezone(this.completedDateTime, this.timezone, isoFormatLong2));
            const completedDateDate = new Date(completedDate.getFullYear(), completedDate.getMonth(), completedDate.getDate());

            return dueDateDate >= completedDateDate ? 'success-bg' : 'warning-bg';
        }

        if (!this.isComplete) {
            if (daysDiff === 0) return 'warning-bg';
            if (daysDiff > 0) return 'success-bg';
            return 'danger-bg';
        }

        return 'default-bg';
    }

    get formattedDateTime(): string {
        const formatted = formatDateWithTimezone(
            this.dueDateTime,
            this.timezone,
            'MMM d, yyyy • h:mmaaa'
        );
        return formatted.replace(/AM|PM/, (m) => m.toLowerCase());
    }

    get timezoneAbbreviation(): string {
        if (this.dueDateTime && this.timezone) {
            const locale = this.$i18n?.locale || 'en-US';
            return getTimeZoneString(new Date(this.dueDateTime), this.timezone, locale);
        }
        return '';
    }

    get showLabel(): boolean {
        return this.labelText !== '';
    }

    get labelText(): string {
        if (this.label !== null && this.label !== undefined) {
            return this.label;
        }
        return this.isMeeting ? 'Start Time' : 'Task Due';
    }
    }
